import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { UNIT_TYPES } from 'constants'
import ScheduleTable from 'containers/Schedule/components/ScheduleTable/ScheduleTable'
import { clearScheduleItemsOfChallenges } from 'helpers/schedule'

import { getCurrentPlayday } from './helpers'
import BattlesNotHeldMessage from './components/BattlesNotHeldMessage/BattlesNotHeldMessage'

import styles from './BattleRoomsSchedule.scss'

export class BattleRoomsSchedule extends React.Component {
    static propTypes = {
        unitType: PropTypes.oneOf(Object.values(UNIT_TYPES)),
        vehicleLevel: PropTypes.number,
        type: PropTypes.oneOf(['allBattleModes', 'oneBattleMode']),

        playdayStart: PropTypes.number,
        playdayEnd: PropTypes.number,
        playdays: PropTypes.array,
    }

    static defaultProps = {
        type: 'oneBattleMode',
    }

    render() {
        if (!this.props.playdays) return null
        let playday = getCurrentPlayday(
            this.props.playdays, this.props.vehicleLevel, this.props.unitType
        )
        if (playday) playday.schedule_items = clearScheduleItemsOfChallenges(playday.schedule_items)

        const baseClassNames = classNames(styles.base, {
            [styles.isAllModes]: this.props.type === 'allBattleModes',
        })

        return (
            <div className={baseClassNames}>
                <h3 className={styles.title}>
                    <BattlesNotHeldMessage
                        playdayEnd={this.props.playdayEnd}
                        playdays={this.props.playdays}
                        playdayStart={this.props.playdayStart}
                        unitType={this.props.unitType}
                        vehicleLevel={this.props.vehicleLevel}
                    />
                </h3>
                <section className={styles.scheduleWrapper}>
                    {playday &&
                        <ScheduleTable
                            playday={playday}
                            type={this.props.type}
                            unitType={this.props.unitType}
                            vehicleLevel={this.props.vehicleLevel}
                        />
                    }
                </section>
            </div>
        )
    }
}

export const mapStateToProps = ({ schedule }) => {
    return {
        playdayStart: schedule.playday_start,
        playdayEnd: schedule.playday_end,
        playdays: schedule.playdays,
    }
}

export default connect(mapStateToProps)(BattleRoomsSchedule)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/BattleRoomsSchedule/BattleRoomsSchedule.jsx